import { useNavigate as useNavigateRouter } from 'react-router-dom';

import { PageRoute } from '../types/page.types';

export const useNavigate = (endpoint: PageRoute) => {
  const navigate = useNavigateRouter();

  return (searchParams: (number | string)[] = []) =>
    navigate(`${endpoint}${searchParams ? '/' + searchParams.join('/') : ''}`);
};
